import React from "react";
import { useTheme } from "@mui/material/styles";
import { FormProvider, useFormContext } from "./FormContext";
import Heading from "./components/Heading";
import Conditions from "./components/Conditions";
import Last from "./components/Last";
import { Box } from "@mui/material";
import { toast } from "react-toastify";

function HomeContent() {
  const theme = useTheme();
  const { formData } = useFormContext();

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("🚀 ~ handleSubmit ~ formData:", formData);
    const requiredFields = [
      "date",
      "parent",
      "student",
      "regNo",
      "grade",
      "name",
      "mobileNumberFather",
      "mobileNumberMother",
      "residenceTel",
      "useremail",
    ];
    const missingFields = requiredFields.filter((field) => !formData[field]);
    if (missingFields.length > 0) {
      toast.error("Please fill all the input fields");
      return;
    }
    if (!formData.agreeToTerms) {
      toast.error("Please agree to terms");
      return;
    }

    // Show the "PDF generating" toast
    const generatingToast = toast.info("PDF generating, don't close the screen", {
      autoClose: false,
      closeOnClick: false,
      closeButton: false,
      draggable: false,
    });

    const API_BASE_URL =
      process.env.REACT_APP_BASE_API_URL ||
      process.env.REACT_APP_BASE_API ||
      "http://localhost:8000/api/";

    try {
      const response = await fetch(`${API_BASE_URL}generatepdfandsend`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          email: "omalharshanuwan@gmail.com", // Hardcoded email
        }),
      });

      // Close the "PDF generating" toast
      toast.dismiss(generatingToast);

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = "agreement.pdf";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        toast.success("PDF downloaded to your PC and email sent to the school");
      } else {
        const errorData = await response.json();
        toast.error(errorData.message || "An error occurred");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred while processing your request");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Heading />
      <Conditions />
      <Last />
    </form>
  );
}

function Home() {
  return (
    <FormProvider>
      <Box sx={{ px: { xs: 2, sm: 4, md: 6, lg: 8 } }}>
        <HomeContent />
      </Box>
    </FormProvider>
  );
}

export default Home;
